import { Controller } from "@hotwired/stimulus"

// data-controller="group-registrations"
export default class extends Controller {
    static targets = ["container", "row", "template", "number"]

    connect() {
        this.index = this.rowTargets.length
        this.updateRowNumbers()
    }

    addRow() {
        const template = this.templateTarget
        const clone = template.content.cloneNode(true)

        // Заменяем INDEX на уникальный индекс
        const wrapper = document.createElement('tbody')
        wrapper.appendChild(clone)
        wrapper.innerHTML = wrapper.innerHTML.replace(/INDEX/g, this.index)

        this.containerTarget.appendChild(wrapper.firstElementChild)
        this.index++
        this.updateRowNumbers()
    }

    removeRow(event) {
        const row = event.target.closest('[data-group-registrations-target="row"]')

        // Не удаляем последнюю строку
        if (this.rowTargets.length > 1) {
            row.remove()
            this.updateRowNumbers()
        } else {
            alert("Должен остаться хотя бы один участник")
        }
    }

    updateRowNumbers() {
        this.rowTargets.forEach((row, index) => {
            const numberCell = row.querySelector('[data-group-registrations-target="number"]')
            if (numberCell) {
                numberCell.textContent = index + 1
            }
        })
    }
}
